function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3867 7.61331L10.6933 3.84665C10.4667 3.52665 10.1 3.33331 9.70667 3.33331C8.71334 3.33331 8.14 4.45331 8.71334 5.25998L10.6667 7.99998L8.71334 10.74C8.13334 11.5466 8.71334 12.6666 9.70667 12.6666C10.1 12.6666 10.4733 12.4733 10.7 12.1533L13.3933 8.38665C13.5533 8.15331 13.5533 7.84665 13.3867 7.61331Z",
  fill: "#30327F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.72002 7.61331L6.03335 3.84665C5.80001 3.52665 5.43335 3.33331 5.04001 3.33331C4.04668 3.33331 3.46668 4.45331 4.04668 5.25998L6.00001 7.99998L4.04668 10.74C3.46668 11.5466 4.04668 12.6666 5.04001 12.6666C5.43335 12.6666 5.80668 12.4733 6.03335 12.1533L8.72668 8.38665C8.88668 8.15331 8.88668 7.84665 8.72002 7.61331Z",
  fill: "#30327F"
});
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.8b581abee87b68a661789e128849350a.svg";
export { ForwardRef as ReactComponent };